import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderSlot as _renderSlot, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  class: "badge-wrapper",
  "data-test": "assessment-badges"
}
const _hoisted_5 = {
  class: "assessment-description",
  "data-test": "assessment-description"
}
const _hoisted_6 = {
  key: 1,
  class: "retake_understanding",
  "data-test": "retake_understanding"
}
const _hoisted_7 = { "data-test": "assessment-info" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = {
  slot: "content",
  class: "accordion-content"
}

import { useRouter } from "vue-router";
import { computed } from "vue";
import { useAssessmentStore } from "@/store";
import AppButton from "@/components/Common/AppButton/AppButton.vue";
import { SanityBlocks } from "sanity-blocks-vue-component";
import { IonAccordionGroup, IonAccordion, IonItem } from "@ionic/vue";
import AssessmentBadges from "@/components/Assessment/AssessmentBadges/AssessmentBadges.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'AssessmentDetailContent',
  props: {
  assessment: { type: Object, required: true },
  assessmentScoresExist: { type: Boolean, required: true },
  incompleteAssessmentExist: { type: Boolean, required: true },
},
  setup(__props) {

const router = useRouter();
const assessmentStore = useAssessmentStore();
const i18n = useI18n();
const props = __props;

const buttonLabel = computed(() => {
  if (props.incompleteAssessmentExist) return i18n.t("assessment.continueQuiz");
  return props.assessmentScoresExist
    ? `${i18n.t("assessment.retake")} ${
        props.assessment.badge?.toLowerCase() || "quiz"
      }`
    : i18n.t("assessment.startQuiz");
});
const startQuiz = async (): Promise<void> => {
  await assessmentStore.startAssessment();
  router.push({
    name: "AssessmentQuestion",
    params: { id: props.assessment.baseId },
  });
};

return (_ctx: any,_cache: any) => {
  return (__props.assessment)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.assessmentScoresExist)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h2", {
                "aria-level": "2",
                class: _normalizeClass(["page-title", __props.assessmentScoresExist ? 'no-margin' : undefined]),
                "data-test": "retake-title"
              }, [
                (__props.assessmentScoresExist)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("assessment.retake")), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(__props.assessment.title), 1)
              ], 2),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(AssessmentBadges, {
                  label: __props.assessment.badge,
                  time: __props.assessment.time,
                  timeUnit: _ctx.$t('assessment.mins')
                }, null, 8, ["label", "time", "timeUnit"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(SanityBlocks), {
            blocks: __props.assessment.description
          }, null, 8, ["blocks"])
        ]),
        _createVNode(AppButton, {
          size: "default",
          type: 
        __props.assessmentScoresExist && !__props.incompleteAssessmentExist
          ? 'secondary'
          : 'primary'
      ,
          label: buttonLabel.value,
          ariaLabel: buttonLabel.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (startQuiz())),
          "data-test": "start-button",
          class: "start-button"
        }, null, 8, ["type", "label", "ariaLabel"]),
        (__props.assessmentScoresExist && __props.assessment.retakeUnderstanding)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_unref(SanityBlocks), {
                blocks: __props.assessment.retakeUnderstanding
              }, null, 8, ["blocks"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(IonAccordionGroup), {
            class: _normalizeClass(["assessment-info", __props.assessmentScoresExist ? 'no-padding' : undefined]),
            id: "accordion-component",
            "data-test": "accordion-component-panel",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonAccordion), { value: "first" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "white"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h2", {
                        "aria-label": _ctx.$t('assessment.aboutAccordion'),
                        "data-test": "accordion-component-label"
                      }, _toDisplayString(_ctx.$t("assessment.aboutAccordion")), 9, _hoisted_8)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_9, [
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                      _createVNode(_unref(SanityBlocks), {
                        blocks: __props.assessment.assessmentInfo
                      }, null, 8, ["blocks"])
                    ])
                  ])
                ]),
                _: 3
              })
            ]),
            _: 3
          }, 8, ["class"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})